import React, {Component} from 'react';
import {connect} from "react-redux";
import {withRouter} from "react-router";
import Layout from '../../components/Layout'
import Home from '../../pages/Home'
import Loading from '../../components/Base/Loading'
import {postActions, postSelectors} from "../../store/posts";
//import { calendarActions } from "../../store/calendar";
// import moment from 'moment'

class HomeContainer extends Component {

	state = {
		width: 0,
		height: 0,
		pinned: [],
		currentPage: 1,
		itemsPerPage: 10,
		posts: [],
		//schedule: [],
		loading: false,
	};

	componentDidMount() {

		const {updateList, updatePinned} = this.props;
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
		this.setState({loading: true});
		// this.getPinnedItems()
		this.pinnedListener = this.props.firebase
			.posts()
			.where('status', '==', 1)
			.where('is_pinned', '==', true)
			// .orderBy('status')
			// .orderBy('is_pinned')
			// .orderBy('post_time', 'desc')
			.onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				// this.setState({pinned: result, loading: false})
				updatePinned(result)
			});

		this.postsListener = this.props.firebase
			.posts()
			.where('status', '==', 1)
			.where('is_pinned', '==', false)
			// .orderBy('status')
			// .orderBy('is_pinned')
			// .orderBy('post_time', 'desc')
			.onSnapshot(snapshot => {
				let result = [];
				snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
				// this.setState({posts: result, loading: false})
				updateList(result)

			})

		//this.scheduleListener = this.getDailyScheduleListener()
		// let first = this.props.firebase.posts().where('status','==', 1).where('is_pinned','==',true).limit(3)

		// this.getPosts()
	}

	nextPinnedPage = () => {
		const {currentPage} = this.state;

		this.setState({currentPage: currentPage + 1})
	};

	prevPinnedPage = () => {
		const {currentPage} = this.state;
		if (currentPage > 1) {
			this.setState({currentPage: currentPage - 1})

		}
	};

	/**
	getDailyScheduleListener = () => {
		const {updateSchedule} = this.props;
		return this.props.firebase.allToth().onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			// this.setState({schedule: result})
			result = result.reverse()
			updateSchedule(result)
			this.fetchTothSchedules(result)
		})
	}
	

	fetchTothSchedules = async (tothList) => {
		const categories = await this.fetchTothCategories()
		for(let i in tothList){
			this.fetchCategorySchedule(categories, tothList[i].date)
		}
		return this.props.firebase.categories().orderBy('created_at', 'asc').onSnapshot(snapshot => {
			let result = [];
			snapshot.forEach(doc => (result.push({id: doc.id, ...doc.data()})));
			// updateCategories(result)
			this.fetchCategorySchedule(result)
		})
	}

	fetchTothCategories = async () => {
		try {
			let categoryRef = await this.props.firebase.categories().orderBy('created_at', 'asc').get()
			let result = [];
			categoryRef.docs.forEach(doc => (result.push({id: doc.id, ...doc.data()})))
			return result
		} catch (e) {
			console.log("failed to fetch toth categories", e)
		}
	}
	*/
	// fetches subcategories and schedules as one
	/*
	fetchCategorySchedule = async (categories, dateString) => {
		const { updateToth} = this.props;
		let newToth = {
			date: dateString,
			schedule: categories.map(category => ({id: category.id, category: category.name, details: []}))
		}
		try {
			for(let i in categories){
				let scheduleRef = await this.props.firebase.calendarSchedule(categories[i].id, dateString).get()
				let schedule = {...scheduleRef.data()}
				// let schedule = scheduleRef.ref.data()
				for(let j in schedule.schedule){
					let subcategoryRef = await this.props.firebase.calendarSubcategory(categories[i].id, schedule.schedule[j]).get()
					newToth.schedule[i].details.push({id: subcategoryRef.id, ...subcategoryRef.data()})
				}


			}

			for(let i = newToth.schedule.length - 1; i >=0; i--){
				if(newToth.schedule[i].details.length === 0){
					newToth.schedule.splice(i, 1);
				}
			}
			// console.log(newToth)
			updateToth(newToth)
			// this.setState({toth: newToth})

		} catch (error) {
			console.log('Failed to fetch schedule', error)
		}
	}

	// updates calendar date in redux and redirects to calendar page
	handleSelectSchedule = (date) => {
		const {updateDate, history} = this.props;
		const isoString = moment(date).toDate()
		updateDate(isoString)
		history.push('/app/calendar')

	}
	*/

	// Did Update.
	componentDidUpdate(prevProps, prevState) {
		// const isDifferentPage = this.state.currentPage !== prevState.currentPage
		// if (isDifferentPage) this.getPosts()
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);

		this.pinnedListener();
		this.postsListener()
		//this.scheduleListener();
		// this.pageListener()
	}


	updateWindowDimensions = () => {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	};

	render() {
		const {   width } = this.state;
		const {
			profile,
			pinned,
			posts,
			loading, 
			school,
			//schedule
		} = this.props;
		return (
			<Layout {...this.props}>
				{profile === null ? <Loading/> :
					<Home
						loading={loading}
						{...this.props}
						width={width}
						pinned={pinned}
						posts={posts}
						nextPinned={this.nextPinnedPage}
						prevPinned={this.prevPinnedPage} 
						school={school}
						//schedules={schedule} selectSchedule={this.handleSelectSchedule}
					/>
				}
			</Layout>
		);
	}
}

const mapStateToProps = (state) => ({
	loading: postSelectors.isLoading(state.posts),
	posts: postSelectors.refreshList(state.posts),
	pinned: postSelectors.refreshPinned(state.posts),
	//schedule: postSelectors.refreshSchedule(state.posts)
});

const mapDispatchToProps = (dispatch) => ({
	updateList: (data) => dispatch(postActions.updateList(data)),
	updatePinned: (data) => dispatch(postActions.updatePinned(data)),
	//updateDate: (date) => dispatch(calendarActions.updateDate(date)),
	//updateSchedule: (data) => dispatch(postActions.updateSchedule(data)),
	//updateToth: (data) => dispatch(calendarActions.updateToth(data))
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeContainer));
